  import { useEffect, useState, useContext } from "react";
  import { FilterDropdown, StandardButton } from "../atoms/buttons";
  import { HorizontalLayout, VerticalLayout } from "../components/layout";
  import { Spinner } from "../atoms/spinner";
  import { deleteAPI, fetchAPI, getAPI, postAPI, updateAPI } from "../api/api";
  import { icon } from "../functions/icons";
  import { EmployeesList } from "../components/employeeslist";
  import { Modal, ModalTitle, ModalBody } from "../components/modal";
  import { InputForm, SelectInputForm } from "../atoms/input";
  import { ToastContext, UserContext } from "../App";
  import { AddEmployeeModal } from "../components/addEmployee";
  import { IconText } from "../components/courseComp";
  import { StandardComp } from "../atoms/standardComp";
  import { toPadding } from "chart.js/helpers";
  import { Alert } from "../components/alert";
  import { HeaderTitle } from "../molecule/headerTitle";

  export function Students({ pageSwap, goToProfile }) {
    const userContext = useContext(UserContext);
    const toastContext = useContext(ToastContext);
    const [students, setStudents] = useState([]);
    const [roles, setRoles] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [selectedDepartments, setSelectedDepartments] = useState([]);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [editModalData, setEditModalData] = useState({});
    const [ErrorMessage, setErrorMessage] = useState("");
    const [originalEmail, setOriginalEmail] = useState("");
    const [emailChanged, setEmailChanged] = useState(false);
    const [confirmEmailChange, setConfirmEmailChange] = useState(false);  
    const [activeFilters, setActiveFilters] = useState([]);
    const [createModalVisible, setCreateModalVisible] = useState(false);
    const [editModalVisible, setEditModalVisible] = useState(false);
    const [createModalStep, setCreateModalStep] = useState(1);
    const [editModalStep, setEditModalStep] = useState(1);
    const [createModalData, setCreateModalData] = useState({});
    const [deleteModalVisible, setDeleteModalVisible] = useState(false);
    const [departmentsModalVisible, setDepartmentsModalVisible] = useState(false);
    const [deleteModalData, setDeleteModalData] = useState({userId: 0, userName: "", });
    const isAdmin = userContext.permissions.includes("company.manage.edit.email");

    const isPublic = userContext.account_type === 1
    function updateCreatedUser(value, key) {
      if (editModalVisible && key === "email") {
        setEmailChanged(value !== originalEmail);
        setConfirmEmailChange(false); 
      }
      
      if (editModalVisible) {
        setEditModalData((prev) => ({ ...prev, [key]: value }));
      } else {
        setCreateModalData((prev) => ({ ...prev, [key]: value }));
      }
    }
  const filteredStudents = students.filter((s) => {
    if (activeFilters.length === 0) return true;

    return activeFilters.some((f) => {
      switch (f) {
         case 1: return !!s.email;
        case 2: return !s.email;
        case 3: return !!s.phone_number;
        case 4: return s.departments && s.departments.length > 0;
        case 5: return s.status === 0;        
        case 6: return s.not_connected === 1;
        case 7: return s.open_count === 0;
        default:
          return true;
      }
    });
  });
    const filterOptions = [
      isPublic && { id: 1, label: "Heeft e-mail" },
      isPublic && { id: 2, label: "Geen e-mail" },
      { id: 3, label: "Heeft telefoonnummer" },
      { id: 4, label: `${isPublic ? "Doelgroep" : "Afdeling"} gekoppeld` },
      isPublic && { id: 5, label: "Kaart niet geactiveerd" },      
      isPublic && { id: 6, label: "Geen kaart gekoppeld" },        
      isPublic && { id: 7, label: "Nooit geopend" },  
      
    ].filter(Boolean)
    async function deleteEmployee(userId) {
      await deleteAPI("api/business/employee/remove", { id_employee: userId });
      setDeleteModalVisible(false);
      loadEmployees();
    }
    function addSelectedDepartment(departmentId) {
      if (!selectedDepartments.includes(departmentId)) {
          setSelectedDepartments(prev => [...prev, departmentId]);
      }
    }
    function showEditEmployeeModal(employee_id, employee){
      console.log("Editing employee:", employee_id);
      setEditModalData(employee);
      setEditModalStep(1);
      setEditModalVisible(true);
      fetchEmployeeData(employee_id)
      if (!isAdmin) {
        setErrorMessage("Alleen beheerders kunnen medewerkers bewerken.");
      }
    }

    function showEditDepartmentsModal(userId) {
      setSelectedUserId(userId);
      setDepartmentsModalVisible(true);
    }

    function showDeleteModal(userId, userName) {
      setDeleteModalData({ userId: userId, userName: userName });
      setDeleteModalVisible(true);
    }
    function handleNextStepEditModal() {
      if (emailChanged && !confirmEmailChange) {
        setErrorMessage(<> Weet je zeker dat je het e-mailadres wilt wijzigen? Klik nogmaals op ‘<b>Volgende</b>’ om dit te bevestigen. </>);
        setConfirmEmailChange(true);
      } else {
        setErrorMessage("");
        setEditModalStep(2);
      }
    }
    async function loadDepartments() {
      console.log("Fetching departments...");
      const response = await getAPI("api/business/departments");
      console.log("API Response:", response);

      if (response.status === "ok" && Array.isArray(response.data)) {
        console.log("Departments Data:", response.data);
        setDepartments(response.data);
      } else {
        console.error("Unexpected response format:", response);
      }
    }
    
    const updateDepartments = async () => {

        console.log("Updating departments for user:", selectedUserId);
        console.log("Selected Departments:", selectedDepartments);
        const body = {
          id: selectedUserId,
          departments: selectedDepartments.map((departmentId) => ({
            id_department: departmentId,
          }))}
        console.log("Selected body:", body);

        const response = await postAPI("api/users/departments/update", body);
        console.log("API Response:", response);
        if (response.status === "ok") {
          toastContext.showToast(`${isPublic ? "Doelgroep" : "Afdelingen"} bijgewerkt`, "success");  
          setDepartmentsModalVisible(false);
        }

    };

    const loadEmployees = async () => {
      const url = isPublic ? "api/business/leads" : "api/business/employees";
      const employees = await fetchAPI(url);
      console.log("Employees/Leads loaded:", employees);
      setStudents(employees);
    };
    const loadRoles = async () => {
      const query = "api/business/roles";
      const loadedRoles = await getAPI(query);
      setRoles(loadedRoles.data);   
      setCreateModalData({...createModalData,id_role:loadedRoles.data[0].id})
         
    };

    const createUser = async () => {
      console.log("facckkkkk",createModalData)
      if(!createModalData.id_role && !isPublic) return toastContext.showToast("Selecteer rol!", "error");  
      const query = isPublic ? "api/business/lead/create" :  "api/business/employee/create";
      const res = await postAPI(query, createModalData);
      
      if(res.status ==="ok"){  
        loadEmployees();
        setCreateModalVisible(!createModalVisible);
        const fullName = `${createModalData.first_name} ${createModalData.last_name}`;
        toastContext.showToast(`${isPublic ? "Lead": "Gebruiker"} "${fullName}" succesvol aangemaakt!`, "success");
      }else{
        toastContext.showToast("Er is iets misgegaan bij het aanmaken van de gebruiker. Controleer de gegevens.", "error");
      }
    };
    const saveEditedEmployee = async () => {
      const query = "api/business/employee/update";
      await updateAPI(query, editModalData);
      setEditModalVisible(false);
      loadEmployees();
      setErrorMessage("");
    };
    useEffect(() => {
      loadEmployees();
      if (!isPublic){
        loadRoles();
      }
      loadDepartments();
      console.log("data:",editModalData);
    }, [editModalData]);
  

    const fetchEmployeeData = async (employee_id) => {
      try {
        const query = isPublic ? `api/business/lead/${employee_id}` : `api/business/employee/${employee_id}` ;
        const response = await getAPI(query);
        if (response.status === 'ok') {
          const data = response.data[0];
          setEditModalData(data);
          setOriginalEmail(data.email);
        } else {
          console.error("Failed to fetch employee data:", response);
        }
      } catch (error) {
        console.error("Error fetching employee data:", error);
      }
  };
  const fetchUserDepartments = async () => {
      try {
        const userId = selectedUserId;
        const query = isPublic ? `api/users/${userId}/doelgroep` : `api/users/${userId}/departments`
        const response = await getAPI(query);

        if (response.status === "ok") {
          setSelectedDepartments(response.data.map((dept) => dept.id_department));
        } else {
          console.error("Failed to fetch departments:", response);
        }
      } catch (error) {
        console.error("Error fetching departments:", error);
      }
    };
    const handleCreateUser = (next) => {
      if (!createModalData.first_name || !createModalData.last_name || !createModalData.email ) {
        return toastContext.showToast("Vul alle verplichte velden in: voornaam, achternaam en e-mailadres.", "error");
      } 
      setCreateModalStep(next)
    }
    useEffect(() => {
      if (selectedUserId) {
        fetchEmployeeData(selectedUserId);
      }
    }, [selectedUserId]);

    useEffect(() => {
      if (departmentsModalVisible) {
        fetchUserDepartments();
      }
    }, [departmentsModalVisible]);

    
    return (
      <>
        <VerticalLayout
          className="body-screen standard-padding"
          style={{ boxSizing: "border-box" }}
        >
          <HorizontalLayout>
            <HeaderTitle title={isPublic ? "Leads" : userContext.org_settings.employee_text}/>
            <FilterDropdown options={filterOptions} selectedIds={activeFilters} onChange={setActiveFilters}/>
            {userContext.permissions.includes("users.manage") && (
              <StandardButton
                onClick={() => {
                  setCreateModalVisible(true);
                  setCreateModalData({...{}, id_role:roles[0].id});
                  setCreateModalStep(1);
                }}
                title={<>{icon("plus", 16)}&nbsp;&nbsp;Nieuw {isPublic ? "lead" : "gebruiker"}</>}
              />
            )}
          </HorizontalLayout>
          <EmployeesList
            pagelimit={8}
            deleteEmployee={showDeleteModal}
            showDepartments={(userId) => showEditDepartmentsModal(userId)}
            setEditEmployee={showEditEmployeeModal}
            employees={filteredStudents}
            onOrderOpen={goToProfile}
          />
        </VerticalLayout>

        <Modal
          dismissable={() => setCreateModalVisible(false)}
          visible={createModalVisible}
          size="small"
          content={
            <>
              <ModalTitle
                dismissable={() => setCreateModalVisible(false)}
                hasXmark={true}
                title={`Nieuwe ${isPublic ? "lead" : "gebruiker"} toevoegen`}
              />
              <ModalBody
                style={{ maxWidth: "500px" }}
                content={
                  <>
                    {createModalStep === 1 && (
                      <p className="standard-margin-bottom">
                        <Alert type="info" message={`De ${isPublic ? "lead" : "gebruiker"} ontvangt een welkomstemail op het opgegeven e-mail adres.`}  className={"phone-alert-email standard-margin-bottom"}/>
                        <HorizontalLayout style={{ gap: "1rem" }}>
                          <InputForm
                            value={createModalData?.first_name}
                            typeInput={(v) => updateCreatedUser(v, "first_name")}
                            title="Voornaam"
                            placeholder=""
                          />
                          <InputForm
                            value={createModalData?.last_name}
                            typeInput={(v) => updateCreatedUser(v, "last_name")}
                            title="Achternaam"
                            placeholder=""
                          />
                        </HorizontalLayout>
                        <InputForm
                          value={createModalData?.email}
                          typeInput={(v) => updateCreatedUser(v, "email")}
                          title="Email"
                          placeholder=""
                        />
                        {isPublic && (
                          <InputForm
                            value={createModalData?.company_name}
                            typeInput={(v) => updateCreatedUser(v, "company_name")}
                            title="Bedrijfsnaam"
                            placeholder="Optioneel"
                          />
                        )}
                        <InputForm
                          value={createModalData?.phone_number}
                          typeInput={(v) => updateCreatedUser(v, "phone_number")}
                          title="Telefoonnummer"
                          placeholder="Optioneel"
                        />
                      </p>
                    )}
                    {createModalStep == 2 && (
                      <p className="standard-margin-bottom">
                        <HorizontalLayout
                          style={{ boxSizing: "border-box", gap: "1rem" }}
                          className="card-outline small-standard-padding standard-margin-bottom standard-border standard-rounded"
                        >
                          <img
                            src={`https://ui-avatars.com/api/?name=${createModalData?.first_name} ${createModalData?.last_name}&background=random&color=fff`}
                            style={{ height: "4rem", width: "4rem" }}
                            className="rounded-img"
                          />
                          <div>
                            <b>
                              {createModalData?.first_name}{" "}
                              {createModalData?.last_name}
                            </b>
                            <p style={{ color: "var(--grey-700)" }}>
                              {createModalData?.email}
                            </p>
                          </div>
                        </HorizontalLayout>
                      
                        <SelectInputForm
                          style={{ width: "413px" }}
                          value={createModalData.id_role || ""}
                          onChange={(v) => updateCreatedUser(v, "id_role")}
                          title={`${isPublic ? "Lead" : "Gebruiker"} rol`}
                          placeholder="Rol"
                          options={roles.map((role) => {
                            return (
                              <option key={role.id} value={role.id}>{role.content}</option>
                            );
                          })}
                        />
                      </p>
                    )}
                    <HorizontalLayout
                      style={{ justifyContent: "flex-end", gap: "1rem" }}
                    >
                      {createModalStep === 1 && (
                        <>
                          <StandardButton
                            className="secondary-button"
                            style={{ marginLeft: "0px" }}
                            title="Annuleren"
                            onClick={() => setCreateModalVisible(false)}
                          />
                          {isPublic ? (  
                            <StandardButton
                              style={{ marginLeft: "0px" }}
                              title={<>Aanmaken</>}
                              onClick={createUser}
                            />) : (
                            <StandardButton
                              style={{ marginLeft: "0px" }}
                              title={<>Volgende {icon("chevron-right")}</>}
                              onClick={() => handleCreateUser(2)}
                          />)}
                        </>
                      )}
                      {createModalStep !== 1 && (
                        <>
                          <StandardButton
                            className="secondary-button"
                            style={{ marginLeft: "0px" }}
                            title={<>Vorige</>}
                            onClick={() => setCreateModalStep(1)}
                          />
                          <StandardButton
                            style={{ marginLeft: "0px" }}
                            title={<>Aanmaken {icon("chevron-right")}</>}
                            onClick={createUser}
                          />
                        </>
                      )}
                    </HorizontalLayout>
                  </>
                }
              />
            </>
          }
        />
        <Modal
          dismissable={() => setEditModalVisible(false)}
          visible={editModalVisible}
          size="small"
          content={
            <>
              <ModalTitle
                dismissable={() => setEditModalVisible(false)}
                hasXmark={true}
                title={`${isPublic ? "Lead" : "Gebruiker"} bewerken${(selectedUserId === userContext.id_users) && !isPublic ? " (Jezelf)" : ""}`}
              />
              <ModalBody
                style={{ maxWidth: "500px" }}
                content={
                  <>
                    {editModalStep === 1 && (
                      <p className="standard-margin-bottom">
                        <HorizontalLayout style={{ gap: "1rem" }}>
                          <InputForm
                            value={editModalData?.first_name}
                            typeInput={(v) => updateCreatedUser(v, "first_name")}
                            title="Voornaam"
                            placeholder=""
                          />
                          <InputForm
                            value={editModalData?.last_name}
                            typeInput={(v) => updateCreatedUser(v, "last_name")}
                            title="Achternaam"
                            placeholder=""
                          />
                        </HorizontalLayout>
                        <InputForm
                          value={editModalData?.email}
                          typeInput={(v) => updateCreatedUser(v, "email")}
                          title="Email"
                          placeholder=""
                          disabled={!isAdmin}
                        />
                        {ErrorMessage && (<Alert type="warning" message={ErrorMessage}  className={"phone-alert-email small-standard-margin-bottom"}/>)}
                        {isPublic && (
                          <InputForm
                            value={editModalData?.company_name}
                            typeInput={(v) => updateCreatedUser(v, "company_name")}
                            title="Bedrijfsnaam"
                            placeholder="Optioneel"
                          />
                        )}
                        <InputForm
                          value={editModalData?.phone_number}
                          typeInput={(v) => updateCreatedUser(v, "phone_number")}
                          title="Telefoonnummer"
                          placeholder="Optioneel"
                        />
                      </p>
                    )}
                    {editModalStep === 2 && (
                      <p className="standard-margin-bottom">
                        <HorizontalLayout
                          style={{ boxSizing: "border-box", gap: "1rem" }}
                          className="card-outline small-standard-padding standard-margin-bottom standard-border standard-rounded"
                        >
                          <img
                            src={`https://ui-avatars.com/api/?name=${editModalData?.first_name} ${editModalData?.last_name}&background=random&color=fff`}
                            style={{ height: "4rem", width: "4rem" }}
                            className="rounded-img"
                          />
                          <div>
                            <b style={{ color: "var(--standard-text-color)" }}>
                              {editModalData?.first_name}{" "}
                              {editModalData?.last_name}
                            </b>
                            <p style={{ color: "var(--standard-text-color-light)" }}>
                              {editModalData?.email}
                            </p>
                          </div>
                        </HorizontalLayout>
                        <div className="phone-role-selector">
                        <SelectInputForm
                          style={{ width: "413px" }}
                          value={editModalData?.id_role} 
                          onChange={(v) => updateCreatedUser(v, "id_role")}
                          title={`${isPublic ? "Lead" : "Gebruiker"} rol`}
                          placeholder="Rol"
                          options={[
                            <option key="current-role" value={editModalData?.id_role} disabled selected>
                              {roles.find((r) => r.id === editModalData?.id_role)?.content || "Huidige rol"}
                            </option>,
                            ...roles
                              .filter((role) => role.id !== editModalData?.id_role)
                              .map((role) => (
                                <option key={role.id} value={role.id}>
                                  {role.content}
                                </option>
                              )),
                          ]}
                        />
                        </div>
                      </p>
                    )}
                    <HorizontalLayout
                      style={{ justifyContent: "flex-end", gap: "1rem" }}
                    >
                      {editModalStep === 1 && (
                        <>
                          <StandardButton
                            className="secondary-button"
                            style={{ marginLeft: "0px" }}
                            title="Annuleren"
                            onClick={() => setEditModalVisible(false)}
                          />
                          {isPublic ? ( 
                            <StandardButton
                              style={{ marginLeft: "0px" }}
                              title={<>Bewerken</>}
                              onClick={saveEditedEmployee}
                            />) : (
                            <StandardButton
                              style={{ marginLeft: "0px" }}
                              title={<>Volgende {icon("chevron-right")}</>}
                              onClick={handleNextStepEditModal}
                          />)}
                        </>
                      )}
                      {editModalStep !== 1 && (
                        <>
                          <StandardButton
                            className="secondary-button"
                            style={{ marginLeft: "0px" }}
                            title={<>Vorige</>}
                            onClick={() => setEditModalStep(1)}
                          />
                          <StandardButton
                            style={{ marginLeft: "0px" }}
                            title={<>Bewerken {icon("chevron-right")}</>}
                            onClick={saveEditedEmployee}
                          />
                        </>
                      )}
                    </HorizontalLayout>
                  </>
                }
              />
            </>
          }
        />
        <Modal
          dismissable={() => setDeleteModalVisible(false)}
          visible={deleteModalVisible}
          size="small"
          content={
            <>
              <ModalTitle
                dismissable={() => setDeleteModalVisible(false)}
                hasXmark={true}
                title={`${isPublic ? "Lead": "Gebruiker"} verwijderen`}
              />
              <ModalBody
                style={{ maxWidth: "400px" }}
                content={
                  <>
                    <p className="standard-margin-bottom">
                      Weet u zeker dat u <b>{deleteModalData.userName}</b> wilt
                      verwijderen? Al zijn/haar gegevens zullen verloren gaan.
                      Deze actie kan niet ongedaan worden gemaakt.
                    </p>
                    <HorizontalLayout
                      style={{ justifyContent: "flex-end", gap: "1rem" }}
                    >
                      <StandardButton
                        className="secondary-button"
                        style={{ marginLeft: "0px" }}
                        title="Nee, toch niet"
                        onClick={() => setDeleteModalVisible(false)}
                      />
                      <StandardButton
                        style={{ marginLeft: "0px" }}
                        backgroundColor="error-600"
                        title="Ja, verwijder"
                        onClick={() => deleteEmployee(deleteModalData.userId)}
                      />
                    </HorizontalLayout>
                  </>
                }
              />
            </>
          }
        />
        <Modal
          dismissable={() => setDepartmentsModalVisible(false)}
          visible={departmentsModalVisible}
          size="small"
          content={
            <>
              <ModalTitle
                dismissable={() => setDepartmentsModalVisible(false)}
                hasXmark={false}
                title={`${isPublic ? "Doelgroep" : "Afdeling"} aanpassen`}
              />
              <ModalBody
                style={{ maxWidth: "400px" }}
                content={
                  <>
                    <VerticalLayout
                      style={{ boxSizing: "border-box",  overflow:"hidden", }}
                      className="card-outline standard-margin-bottom standard-border standard-rounded"
                    >
                      {SelectedDepartments(
                        departments,
                        selectedDepartments,
                        setSelectedDepartments
                      )}
                    </VerticalLayout>
                    <HorizontalLayout>
                      <DepartmentSelectors
                        departments={departments}
                        selectedDepartments={selectedDepartments}
                        createModalData={createModalData}
                        updateCreatedUser={updateCreatedUser}
                        addSelectedDepartment={addSelectedDepartment}
                        />
                    </HorizontalLayout>
                    <HorizontalLayout
                      style={{ justifyContent: "flex-end", gap: "1rem" }}
                    >
                      <StandardButton
                      className={"standard-margin-top"}
                        style={{ marginLeft: "0px" }}
                        title="Wijzigingen opslaan"
                        onClick={updateDepartments}
                      />
                    </HorizontalLayout>
                  </>
                }
              />
            </>
          }
        />
      </>
    );
  }
  function SelectedDepartments( departments, selectedDepartments, setSelectedDepartments) {
      const userInformation = useContext(UserContext)
      const isPublic = userInformation.account_type === 1
      if (selectedDepartments.length === 0) {
        return <p className="small-standard-padding">Geen {isPublic ? "doelgroepen" : "afdelingen"} gekoppeld.</p>;
      }

      return selectedDepartments.map((departmentId) => {
        const department = departments.find(
          (dept) => String(dept.id_department) === String(departmentId)
        );

      if (!department) return null;

      return (
        <VerticalLayout key={department.id_department}>
          <StandardComp
            editClass={"phone-department-comp department-comp horizontal space-between"}
            style={{ padding: "0",}}
            content={
              <>
                <p className="department-name">{department.department_name}</p>
                <div
                  className="remove-icon"
                  onClick={() => {
                    setSelectedDepartments((prevDepartments) => {
                      const newDepartments = prevDepartments.filter(
                        (id) => String(id) !== String(department.id_department)
                      );
                      return newDepartments;
                    });
                  }}
                >
                  <IconText icon2={"x"} />
                </div>
              </>
            }
          />
        </VerticalLayout>
      );
    });
  }

  const DepartmentSelectors = ({departments, selectedDepartments, createModalData, updateCreatedUser, addSelectedDepartment}) => {
      const userInformation = useContext(UserContext)
      const isPublic = userInformation.account_type === 1
      return (
        <SelectInputForm
        style={{ width: "100%" }}
        value={createModalData?.id_department || ""}
        onChange={(e) => {
          const value = e?.target?.value || e;
          console.log("New Department Selected:", value);
          updateCreatedUser(value, "id_department");
          addSelectedDepartment(value);
        }}
        title={`Kies een ${isPublic ? "doelgroep" : "afdeling"}`}
        placeholder={isPublic ? "Doelgroep" : "Afdeling"}
        options={[
          <option key="dummy-option" value="" disabled>
            Selecteer een {isPublic ? "doelgroep" : "afdeling"}
          </option>,
          ...departments
            .filter((dept) => !selectedDepartments.includes(dept.id_department))
            .map((dept) => (
              <option key={dept.id_department} value={dept.id_department}>
                {dept.department_name}
              </option>
            )),
        ]}
      />
    );
  }
